<app-eca-modal-host (cancelClicked)="cancelClicked()"
                    (helpClicked)="helpClicked()"
                    (saveClicked)="saveClicked()"
                    [editButtonIcon]="['far', 'edit']"
                    [heading]="heading"
                    [isEditing]="true"
                    [noButtonIcon]="['far', 'times']"
                    [yesButtonIcon]="['far', 'save']"
                    class="modal-eca modal-eca-success"
                    noButtonColour="transparent">
  <div class="container">
    <div *ngIf="showingHelp" class="row">
      <div class="col">
        <app-eca-help-alert (helpCloseClicked)="helpClicked()" [helpHtmlText]="helpMessage"></app-eca-help-alert>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div *ngIf="loadingOperatives" class="text-center">
          <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
        </div>
        <div *ngIf="!loadingOperatives">
          <p-table #operativesTable [value]="operatives" [(selection)]="selectedOperatives"
                   [globalFilterFields]="['fullName', 'firstName', 'lastName','referenceNumbers','jobTitle','currentWorkRisk.label','currentEmploymentStatus.label','jobLevel.label','currentRiskMatrixLevel.label','startedOn','nextObservationFollowUp', 'totalCPDHours']" dataKey="id"
                   styleClass="p-datatable-striped p-datatable-responsive-eca" [scrollable]="!isOnMobile &&    operatives.length > 5" scrollHeight="500px" [responsive]="true" [columns]="columns" [totalRecords]="operatives?.length">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 6%" class="text-center" *ngIf="showMultiSelect">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th style="width: 7%" pSortableColumn="firstName">
                  First Name
                  <p-sortIcon field="firstName"></p-sortIcon>
                </th>
                <th style="width: 7%" pSortableColumn="lastName">
                  Last Name
                  <p-sortIcon field="lastName"></p-sortIcon>
                </th>
                <th style="width: 10%" pSortableColumn="businessUnit">
                  Current Business Unit
                  <p-sortIcon field="businessUnit"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-operative let-columns="columns">
              <tr>
                <td class="text-center" *ngIf="showMultiSelect">
                  <p-tableCheckbox [value]="operative"></p-tableCheckbox>
                </td>
                <td *ngFor="let col of columns">
                  <span class="p-column-title">{{col.header}}: </span>
                  <label>
                    <span *ngIf="col.type=== 'text'">
                      {{ operative[col.field] }}
                    </span>                    
                  </label>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</app-eca-modal-host>
